<template>
  <div id="app">
    
    <navigation-bar class="psl__navbar" />

    <transition name="fade">
      <b-container class="psl__main-container d-flex flex-column" key="mainContent"
        v-if="currentUser">
        <router-view/>
      </b-container>
      <div class="psl__login-form d-flex flex-column align-items-center justify-content-center p-4" key="loginContent"
        :class="{'psl__login-form--focused' : formIsFocused}"
        v-else>
        <video width="100%" height="100%" autoplay loop muted playsinline class="psl__login-form-video position-absolute w-100 h-100">
          <source src="/video/form-bg.mp4" type="video/mp4">
        </video>
        <b-form class="position-relative p-4 shadow-lg text-center"
          @focusin="formIsFocused = true" @focusout="formIsFocused = false"
          @submit.prevent="submitUser">
          <h2 class="h1 font-weight-bold">PSL</h2>
          <h3 class="mb-4">Personal Seat License</h3>
          <p class="text-light">Introduce tus datos para acceder a la plataforma</p>
          <b-form-group id="input-group-1" label="Usuario" label-for="input-1" label-sr-only>
            <b-form-input id="input-1" type="email" placeholder="Usuario" required autocomplete="email" size="lg"
              v-model="user"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-2" label="Contraseña" label-for="input-2" label-sr-only>
            <b-form-input id="input-2" type="password" placeholder="Contraseña" required autocomplete="current-password" size="lg"
              v-model="pass"></b-form-input>
          </b-form-group>
          
          <div class="text-danger mb-3"
            v-if="currentError">{{currentError}}</div>
        
          <b-button type="submit" variant="primary" size="lg" class="mb-4 px-5">Login</b-button>
          <div>
            ¿Necesitas ayuda? Escríbenos
            <br />
            <a href="mailto:psl-support@fcbarcelona.cat">psl-support@fcbarcelona.cat</a>
          </div>
        </b-form>
      </div>
    </transition>
    
  </div>
</template>

<script>
import NavigationBar from '@/components/NavigationBar.vue'

import { mapState } from 'vuex'

export default {
  name: 'App',
  data() {
    return {
      user: '',
      pass: '',
      formIsFocused: false
    }
  },
  created() {
    fetch('/data/users.json')
      .then(response => response.json())
      .then(data => {
        this.$store.commit('setAllUsers', data);
        if (localStorage.fcbUserId)
          this.$store.commit('setUser', {id: localStorage.fcbUserId});
      });
  },
  components: {
    NavigationBar
  },
  computed: {
    ...mapState(['currentUser', 'currentError'])
  },
  methods: {
    submitUser() {
      this.$store.commit('setUser', {email: this.user, password: this.pass});
    }
  },
  watch: {
    currentUser: {
      handler() {
        this.user = '';
        this.pass = '';
      },
      immediate: true
    }
  }
}
</script>
